import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
    selector: 'app-camera-button',
    standalone: true,
    imports: [CommonModule],
    templateUrl: './camera-button.component.html',
    styleUrl: './camera-button.component.scss'
})
export class CameraIconButtonComponent {
    @Input() ariaLabel: string = 'Change photo';
    @Input() variant: 'profile' | 'cover' | 'vessel' = 'profile';
    @Output() clicked = new EventEmitter<void>();

    onClick(event: Event): void {
        event.stopPropagation();
        this.clicked.emit();
    }
}
